module.exports = __webpack_public_path__ + "static/media/wecan_software.5dd0ede7.svg";